package dev.lingvo.shared.screenshots.text

/** Deterministic common fallback deliberately avoids guessing dictionary word boundaries. */
object RuleSegmenter : Segmenter {
    /** Retaining delimiters lets callers preserve hard lines while hiding discretionary controls at draw time. */
    override fun segments(text: String, locale: String): List<Segment> = buildList {
        var start = 0
        for (i in text.indices) {
            val c = text[i]
            val kind = when {
                c == '\n' -> Brk.HARD
                c == ' ' -> Brk.SPACE
                c == '\u200b' -> Brk.ALLOWED
                c == '\u00ad' -> Brk.SOFT_HYPHEN
                (c == '-' || c == '\u2010') && i > 0 && i < text.lastIndex &&
                    text[i - 1].isLetter() && text[i + 1].isLetter() -> Brk.ALLOWED
                else -> Brk.NONE
            }
            val glued = kind != Brk.HARD && text.getOrNull(i + 1) in listOf('\u00a0', '\u202f', '\u2060')
            if (kind != Brk.NONE && !glued) {
                add(Segment(text.substring(start, i + 1), kind))
                start = i + 1
            }
        }
        if (start < text.length) add(Segment(text.substring(start), Brk.NONE))
    }
}
